import { ContainerRowB as ContainerRowBDS } from "@dbn/omnichannel-design-system-g4p/";
import { CommonProps } from "../CommonProps";

type Props = CommonProps & {
  imageUrl: string;
};

export function ContainerRowB(props: Props) {
  return <ContainerRowBDS {...props} />;
}
